import Request from '../Request.utils'
export interface ITemplatesByProductRequestQuery {
  productId: string;
}
export interface ISaveTemplateRequestBody {
  data: object;
  id?: string;
  productId: string;
  thumbnail?: string;
}
export interface IDeleteTemplateRequestParams {
  id: string;
}


class ItlAPI {
  templatesByProduct = async (query: ITemplatesByProductRequestQuery) => {
    const res = await Request.call('/api/itl/templates-by-product', 'GET', undefined, query, undefined, );
    return res;
  }
  saveTemplate = async (body: ISaveTemplateRequestBody) => {
    const res = await Request.call('/api/itl/save-template', 'POST', undefined, undefined, body, );
    return res;
  }
  deleteTemplate = async (params: IDeleteTemplateRequestParams) => {
    const res = await Request.call('/api/itl/template/:id', 'DELETE', params, undefined, undefined, );
    return res;
  }
}
export default new ItlAPI()